import React, { memo, useCallback, useState } from 'react';
import cx from 'classnames';
import { MdFirstPage, MdLastPage } from 'react-icons/md';
import Button from '../../../components/Button';
import Input from '../../../components/input/Input/Input';
import Select from '../../../components/input/Select/Select';
import {
  GLOBAL_SEARCH_TYPE,
  GLOBAL_SEARCH_TYPE_SELECT_LIST,
  GLOBAL_SEARCH_TYPE_URL,
} from '../../../constants/service/common/commonConstants';
import { openNewWindow, setDetailPageUrl } from '../../../lib/common';
import './Head.scss';
import { useAuth } from '../../../hooks/common/useAuth';

const Head = (props) => {
  const { isCollapsed, color, sidebarToggleCollapse } = props;
  const [searchKeywordType, setSearchKeywordType] = useState(GLOBAL_SEARCH_TYPE.PRODUCT_DETAIL_URL_TYPE);
  const [searchKeyword, setSearchKeyword] = useState(null);

  const { logout, user } = useAuth();

  const onSearch = useCallback(() => {
    openNewWindow(setDetailPageUrl(GLOBAL_SEARCH_TYPE_URL[searchKeywordType], searchKeyword));
  }, [searchKeywordType, searchKeyword]);

  return (
    <div className={cx('main-head', color, { isCollapsed })}>
      <div className="left-area">
        {isCollapsed ? (
          <MdLastPage onClick={() => sidebarToggleCollapse(false)} />
        ) : (
          <MdFirstPage onClick={() => sidebarToggleCollapse(true)} />
        )}
        <div className="admin-info">
          <a href={`/account/admin/detail/${user?.id}`}>{user?.name}</a>
        </div>
      </div>

      <div className="right-area">
        <div className="global-search-wrap">
          <Select
            list={GLOBAL_SEARCH_TYPE_SELECT_LIST}
            onChange={(type) => setSearchKeywordType(type)}
            value={searchKeywordType}
            size="default"
          />

          <Input
            value={searchKeyword}
            onChange={(value) => setSearchKeyword(value)}
            onPressEnter={() => onSearch()}
            maxLength={30}
            size="large"
          />
        </div>
        <Button className="logoutBtn" onClick={logout} text="로그아웃" />
      </div>
    </div>
  );
};

export default memo(Head);
